import {
  AutoComplete,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Select,
  Tooltip,
} from "antd";
import { FormInstance } from "antd/lib/form/Form";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Item } from "types/models/colums-table-type";
import type { InputRef } from "antd";
import { FIELD_TYPE } from "types/enums";
import { Rule } from "antd/es/form";
import { setData } from "redux/reducer/pending";
import { options } from "pages/NurseOut/ExamHistory/config";
import { formatDateToString } from "helper/common";

const { INPUT, DATE, CURRENCY, AUTO_COMPLETE, COMBO_BOX } = FIELD_TYPE;

type EditableRowProps = {
  index: number;
};
export type EditableCellProps = {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: any;
  record: any;
  selected: boolean;
  options: any;
  name: string;
  index: number;
  type: FIELD_TYPE;
  handleSave: (record, index) => void;
  rules: Rule[];
  disabled: boolean;
  value: any;
  onSearch: (record, index) => void;
  onSelect: (record, index) => void;
  optionsTime?: any;
};

export const EditableContext = React.createContext<FormInstance<any> | null>(
  null
);

export const EditableRow: React.FC<EditableRowProps> = ({
  index,
  ...props
}) => {
  const [form] = Form.useForm();
  const onFinishFailed = (errorInfo: any) => {};

  return (
    <Form form={form} component={false} onFinishFailed={onFinishFailed}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

export const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  selected,
  options,
  handleSave,
  onSearch,
  onSelect,
  name,
  index,
  type,
  rules,
  disabled,
  value,
  optionsTime,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<any>(null);
  const form = useContext(EditableContext)!;
  const [inputValue, setInputValue] = useState({});
  const onKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
    }
  };
  // const handleSetFieldValue = (dataIndex, value) => {
  //   form.setFieldValue(dataIndex, value);
  //   setInputValue({ ...inputValue, [dataIndex]: value });
  //   handleSave(form.getFieldsValue(), index);
  // };

  useEffect(() => {
    inputRef.current?.focus();
  }, [editing]);
  // const save = async () => {
  //   try {
  //     const values = await form.validateFields();
  //     let row;
  //     row = {
  //       ...record,
  //       ...values,
  //     };
  //   } catch (errInfo) {}
  // };
  // useEffect(() => {
  //   if (record !== undefined) {
  //     form.setFieldValue(dataIndex, record[dataIndex]);
  //   }
  // }, [record]);
  let childNode = children;
  if (type === INPUT) {
    childNode = (
      // editing ? (
      <Form.Item
        rules={rules}
        style={{ margin: 0 }}
        // initialValue={getFieldValue(dataIndex) ?? null}
        name={dataIndex}
        // initialValue={getFieldValue(dataIndex) ?? null}
        initialValue={record[dataIndex]}
      >
        {/* <Tooltip title={record[dataIndex]}> */}
        <Input
          disabled={disabled}
          style={{ padding: 0, height: 70, textAlign: "center" }}
          onChange={(e) => {
            setInputValue({
              ...inputValue,
              [dataIndex]: e.target.value,
            });
            handleSave(form.getFieldsValue(), index);
          }}
        />
        {/* </Tooltip> */}
      </Form.Item>
    );
  }
  if (type == COMBO_BOX) {
    childNode = (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        // initialValue={getFieldValue(dataIndex) ?? null}
        initialValue={record[dataIndex]}
      >
        <Select
          showSearch
          style={{
            width: "100%",
          }}
          filterOption={(input, option) =>
            (option?.label.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
          placeholder={!disabled ? "Chọn" : "--"}
          options={[
            { value: "Bố", label: "Bố" },
            { value: "Mẹ", label: "Mẹ" },
            { value: "Vợ", label: "Vợ" },
            { value: "Chồng", label: "Chồng" },
            { value: "Khác", label: "Khác" },
          ]}
          //  options={listMachine}
          disabled={disabled}
          allowClear={true}
          // onBlur={save}
          // onChange={(e) => {
          //   save();
          // }}
          {...restProps}
        />
      </Form.Item>
    );
  }
  return <td {...restProps}>{childNode}</td>;
};
